<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";
import { ABILITY_TOKEN } from "@casl/vue";
import { fetchOUAccess } from "@/helpers/abilities.js";
import { refreshToken, sessionExpired } from "@/helpers/auth-refresh";

export default {
  name: "App",
  inject: {
    $ability: { from: ABILITY_TOKEN },
  },
  components: {},
  methods: {
    loadOUAccess() {
      if (localStorage.getItem("jwt")) {
        let ouAccess = localStorage.getItem("ouAccess")
          ? JSON.parse(localStorage.getItem("ouAccess"))
          : [];
        if (ouAccess == undefined || ouAccess == null || ouAccess.length == 0) {
          fetchOUAccess();
        }
      }
    },
  },
  computed: {
    rules() {
      return this.$store.state.rules || [];
    },
  },
  created() {
    // axios global request interceptor
    axios.interceptors.request.use(function (config) {
      const token = localStorage.getItem('jwt');
      config.headers.Authorization = `Bearer ${token}`;

      // PUT / PATCH / DELETE to the API go as POST with X-HTTP-Method-Override, which
      // Laravel routes as the original method: web servers and firewalls that only
      // allow GET and POST block them otherwise (403, or "Network Error" as the block
      // has no CORS headers). It also lets PUT send files (PHP parses multipart only on POST).
      const method = (config.method || 'get').toLowerCase();
      const url = String(config.url || '');
      const toApi = !/^https?:\/\//i.test(url) || url.startsWith(process.env.VUE_APP_AUTHDOMAIN || '');
      if (toApi && ['put', 'patch', 'delete'].includes(method)) {
        config.headers['X-HTTP-Method-Override'] = method.toUpperCase();
        config.method = 'post';
      }

      return config;
    });

    // axios global response interceptor
    axios.interceptors.response.use(response => {
      return response;
    }, error => {
      

      // 401: the sign-in token has expired. Renewed once (shared by every request that
      // failed with it), then the request is sent again with the new token; when it
      // can't be renewed, the user is signed out and told why. (A session replaced by
      // a sign-in elsewhere is handled by the system guard.)
      const original = error.config || {};
      const url = String(original.url || '');
      const isAuthCall = /\/api\/(login|logout|refresh|verify|2fa)/.test(url);
      const replaced = error.response?.data?.code === 'session_replaced';
      if (error.response && error.response.status === 401 && !replaced && !isAuthCall && !original._retried && localStorage.getItem('jwt')) {
        return refreshToken()
          .then((token) => {
            original._retried = true;
            original.headers = { ...(original.headers || {}), Authorization: `Bearer ${token}` };
            return axios(original);
          })
          .catch(() => {
            sessionExpired();
            return error;
          });
      }

      return error;
    });

    this.$store.commit("getRules");
    this.$ability.update(this.rules);
  },
  mounted() {
    this.loadOUAccess();
  },
};
</script>

<style>
.introjs-tooltip-header {
  display: none !important;
}

.introjs-tooltip {
  width: 300px !important;
}

.introjs-tooltiptext {
  background-color: rgb(10, 179, 156) !important;
  color: #fff !important;
}

.introjs-tooltipbuttons {
  background-color: rgb(255, 255, 255) !important;
  color: #292929 !important;
}

.introjs-nextbutton {
  color: #ffffff !important;
  background-color: rgba(10, 179, 156) !important;
}

.introjs-prevbutton {
  border: 1px solid gray !important;
  background-color: rgb(255, 255, 255) !important;
  color: gray !important;
}

.introjs-tooltiptext {
  font-size: 15px !important;
}

.introjs-button,
.introjs-button:hover,
.introjs-button:focus,
.introjs-button:active,
.introjs-disabled,
.introjs-disabled:focus,
.introjs-disabled:hover {
  outline: none !important;
  background-image: none !important;
  background-color: rgba(10, 179, 156);
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 0px !important;
  box-shadow: none !important;
  text-shadow: none !important;
}
</style>